import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox } from '@dixa/lib-shared-habla';
import { Field } from 'redux-form';
import { FormSectionTitle } from 'components/settings/components/sections/dixaMessenger/views/appearance/components/formSectionTitle';
import { messengerSettingsFormFields } from 'components/settings/components/sections/dixaMessenger/views/appearance/types';
import { LauncherIconPickerField } from './components/LauncherIconPickerField';
import { DefaultBrandedDixaLauncherIcon, UnbrandedDixaLauncherIcon, } from './components/icons';
export function LauncherIcon() {
    const availableLauncherIcons = [
        {
            id: 'dixa-branded-default',
            icon: _jsx(DefaultBrandedDixaLauncherIcon, { style: { display: 'block' } }),
            title: 'Dixa icon',
            lockedFeature: false,
        },
        {
            id: 'chat-bubbles',
            icon: _jsx(UnbrandedDixaLauncherIcon, { style: { display: 'block' } }),
            title: 'Chat bubbles',
            lockedFeature: false,
        },
    ];
    return (_jsxs("div", { children: [_jsx(FormSectionTitle, { title: _jsx(FlexBox, Object.assign({ alignItems: "center", gap: "200" }, { children: "Custom Launcher icon" })), description: "Select which launcher icon you want to display for your Messenger" }), _jsx(Field, { options: availableLauncherIcons, component: LauncherIconPickerField, name: messengerSettingsFormFields.launcherIconType })] }));
}
